module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-3.c69743b2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-3.mp3
// module id = 133
// module chunks = 0